// En tu archivo de estado Recoil
import { atom } from 'recoil';

export const createModalStateAtom = atom({
  key: 'createModalStateAtom',
  default: {
    isOpen: false,
    onConfirm: () => {},
    onCancel: () => {},
    message: '',
    title: '',
  },
});
